import { initAA } from "~/config/algolia-insights"

export default defineNuxtPlugin(async (nuxtApp) => {
  const runtimeConfig = useRuntimeConfig().public.algolia

  // @ts-ignore
  nuxtApp.vueApp.use(initAA(runtimeConfig))
})
